import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'can_apprentices_trainees_interns_a_position_in_the_fac_that_is'

export const dataPointDefinition = {
  retracedId: 'can_apprentices_trainees_interns_a_position_in_the_fac_that_is',
  name: 'Can apprentices / trainees / interns choose a position in the facility that is related to their area of study (or skill/trade)?',
  description:
    'The intent of this question is to understand if apprentices/interns/trainees can choose a position in the facility that is related to their area of study (or skill/trade area).\r\r\n\r\r\nFor example, if school interns studying finance are required to take a production line position in the finishing department, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-5--5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4830,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
